module.exports = "dist/1e59d2330b4c6deb84b340635ed36249.ttf";